import React from "react"
import { makeStyles } from '@material-ui/core/styles';

import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import InfoIcon from '@material-ui/icons/Info';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  warn: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  sea: {
    paddingTop: theme.spacing(12),
    paddingBottom: theme.spacing(2),
  },
  content: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  }
}));

export const ContentAttention = ({ data }) => {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);
  const [dialogContent, setDialogContent] = React.useState(false);

  const handleClickOpen = (content) => {
    setOpen(true);
    setDialogContent(content);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const warnData = [];
  for (const a of data.loc.jma_warn.obs) {
    for (const b of a.warn) {
      warnData.push(b);
    }
  }
  const warn = warnData.map((a, i) => {
    const d = a.alert;
      return(
        <React.Fragment key={`warn-${i}`}>
          <Grid
            spacing={3}
            container
            align="center"
            alignItems="center"

            className={classes.content}
           >
            <Grid item xs={6} sm={6}>
              <Typography variant="body1" component="p">
                {d.region["#text"]}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={6} >
              <Typography variant="body1" component="p">
                {d["-name"]}
              </Typography>
            </Grid>
          </Grid>
          <Divider />
        </React.Fragment>
      )
    })

  const seaData = [];
  for (const a of data.loc.jma_seawarn.obs_sea) {
    for (const b of a.warn) {
      seaData.push(b);
    }
  }
  const sea = seaData.map((a, i) => {
    const d = a.alert;
      return(
        <React.Fragment key={`warn-${i}`}>
          <Grid
            spacing={3}
            container
            align="center"
            alignItems="center"

            className={classes.content}
           >
            <Grid item xs={6} sm={6}>
              <Typography variant="body1" component="p">
                {d.region["#text"]}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={6} >
              <Typography variant="body1" component="p">
                {d["-name"]}
                { d["comment"] &&
                  <IconButton onClick={() => handleClickOpen(d["comment"]["#text"])}>
                    <InfoIcon size="large" />
                  </IconButton>
                }
              </Typography>
            </Grid>
          </Grid>
          <Divider />
        </React.Fragment>
      )
    });
  return (
    <React.Fragment>
      <div id="warn" className={classes.warn}>
        <Typography variant="body1" component="p">注意報・警報</Typography>
        <Divider />
        {warn}
      </div>
      <div id="sea" className={classes.sea}>
        <Typography variant="body1" component="p">海上警報</Typography>
        <Divider />
        {sea}
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">海上警報</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dialogContent}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default ContentAttention